import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService }    from '@ngx-translate/core';

@Pipe({
  name: 'inspectionStatus',
})
export class InspectionStatusPipe implements PipeTransform {

  constructor(
    private translateService : TranslateService
  ) {}

  transform( value : any ) {
    switch (value) {
      case 'A':
        return this.translateService.instant('INSPECTIONS_SPACE.STATUS.APPROVED');
      case 'D':
        return this.translateService.instant('INSPECTIONS_SPACE.STATUS.DRAFTS');
      case 'F':
          return this.translateService.instant('INSPECTIONS_SPACE.STATUS.FINALISED');
      case 'FW':
          return this.translateService.instant('JS_SPACE.INSPECTIONS.FINALISED_WORK');
      case 'R':
        return this.translateService.instant('INSPECTIONS_SPACE.STATUS.REFUSED');
      case 'RA':
        return this.translateService.instant('INSPECTIONS_SPACE.STATUS.REQUESTED');
      default:
        return '';
    }
  }
}